import { render, staticRenderFns } from "./mobileHotelMenu.vue?vue&type=template&id=2493e80c&"
import script from "./mobileHotelMenu.vue?vue&type=script&lang=js&"
export * from "./mobileHotelMenu.vue?vue&type=script&lang=js&"
import style0 from "./mobileHotelMenu.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports